var N = {
  init: function init(n) {
    void 0 === n && void 0 !== N.zg || (N.zg = !!n), N.l || (N.l = !0);
  },
  destroy: function destroy() {
    N.l = !1, N.zg = void 0, N.vd = void 0;
  },
  setLogger: function setLogger(n) {
    "function" == typeof n ? (N.init(), N.vd = n) : N.info("Ignoring setLogger call since logger is not a function");
  },
  toggleLogging: function toggleLogging() {
    N.init(), N.zg ? (console.log("Disabling Braze logging"), N.zg = !1) : (console.log("Enabled Braze logging"), N.zg = !0);
  },
  info: function info(n) {
    if (N.zg) {
      var o = "Braze: " + n;
      null != N.vd ? N.vd(o) : console.log(o);
    }
  },
  warn: function warn(n) {
    if (N.zg) {
      var o = "Braze SDK Warning: " + n + " (v5.9.0)";
      null != N.vd ? N.vd(o) : console.warn(o);
    }
  },
  error: function error(n) {
    if (N.zg) {
      var o = "Braze SDK Error: " + n + " (v5.9.0)";
      null != N.vd ? N.vd(o) : console.error(o);
    }
  }
};
export default N;